import { Injectable, inject } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';

import { AuthenticationService, CommonService } from '../_services';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root' // ensures DI works with `withInterceptorsFromDi`
})
export class JwtInterceptor implements HttpInterceptor {
  private authenticationService = inject(AuthenticationService);
  private commonService = inject(CommonService);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Append base URL (except for assets or absolute URLs)
    const isApiUrl = !/^https?:\/\//i.test(request.url) && !request.url.startsWith('assets');
    if (isApiUrl) {
      request = request.clone({ url: `${environment?.serviceUrl}${request.url}` });
    }

    const currentUser = this.authenticationService.currentUserValue;
    if (currentUser?.token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${currentUser.token}`
        }
      });
    }

    return next.handle(request);
  }
}
